import React from 'react';
import Button from 'antd/lib/button';
import { ThemeProvider } from '../../layout/ThemeProvider';
import { ThemeConfigKeys } from '../../utils/Constants';

interface SmallButtonProps {
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
  className?: string;
}

const SmallButton: React.FC<SmallButtonProps> = (props) => {
  const { onClick, children, disabled, className } = props;

  return (
    <ThemeProvider themeKey={ThemeConfigKeys.DnataBlueCloseBtn}>
      <Button className={className} onClick={onClick} type="primary" disabled={disabled}>
        {children}
      </Button>
    </ThemeProvider>
  );
};

export default SmallButton;
